import styled from 'styled-components';
import { Select } from '@material-ui/core';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  .text {
    font-size: 13px;
    color: #374065;
    letter-spacing: 0px;
    font-weight: medium;
    font-family: Roboto;
  }
  .input {
    margin-bottom: 20px;
    font-size: 13px;
  }
  .error {
    margin-top: -5px;
    color: red;
    text-align: center;
  }
  .errorSelect {
    margin-top: 9px;
    color: red;
  }
  .subTitle {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .error {
    margin-top: -5px;
    color: red;
    text-align: center;
  }
  .titleAccordion {
    font-size: 15px;
    line-height: 28px;
    font-weight: 500;
    margin-bottom: 20px;
  }
`;

export const StyledSelect = styled(Select)`
  &.MuiInput-underline.Mui-disabled:before {
    border-bottom-style: solid;
  }
  .MuiSelect-icon {
    color: black;
  }
  font-weight: 500;
`;
export const GridWrapper = styled.div`
  margin: 10px 0px;
`;
